export default "__VITE_ASSET__CCeHVqmW__";